import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { apiGet } from 'APIPackage/MainModule/common/apiTools';

import { ITerritorialUnit } from '../interfaces/ITerritorialUnit';

export async function fetchAnalyticsTerritorialUnits(): Promise<ITerritorialUnit[]> {
  return apiGet<ITerritorialUnit[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/analytics-territorial-units`,
  );
}
